import { render, staticRenderFns } from "./MarketerTransactions.vue?vue&type=template&id=a92f8312"
import script from "./MarketerTransactions.vue?vue&type=script&lang=js"
export * from "./MarketerTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports